export type TarefaStatus =
  | 'pendente'
  | 'em_andamento'
  | 'concluida'
  | 'cancelada'
  | 'atrasada'
  | 'concluida_com_pendencias';

export type TarefaPrioridade = 'baixa' | 'media' | 'alta' | 'urgente';

export type TarefaTipo = 'acao' | 'pergunta' | 'checklist';

export interface RegraNavegacao {
  resposta: string;
  proxima_pergunta_id?: string;
  proximo_bloco_id?: string; // ID do bloco que será inserido após esta resposta
}

export interface PerguntaFormulario {
  id: string;
  texto: string;
  tipo_resposta: 'multipla_escolha' | 'discursiva';
  opcoes?: string[];
  obrigatoria?: boolean;
  ordem?: number;
  proxima_pergunta_id?: string;
  proximo_bloco_id?: string; // ID do bloco que será inserido após esta pergunta
  regras_navegacao?: RegraNavegacao[];
  finaliza_fluxo?: boolean;
}

export interface BlocoPerguntas {
  id: string;
  nome: string;
  descricao?: string;
  perguntas: PerguntaFormulario[];
  created_at?: string;
  updated_at?: string;
  created_by?: string;
}

export interface RespostaFormulario {
  pergunta_id: string;
  resposta: string;
}

export interface ConclusaoAutomatica {
  id: string;
  nome: string;
  pergunta_ids: string[]; // IDs das perguntas que, quando respondidas, levam a esta conclusão
}

/** Alinhado a `tarefas_templates.linha_produto` no Supabase. */
export type LinhaProdutoTemplate = 'fotovoltaico' | 'carregador_veicular';

export const LINHA_PRODUTO_TEMPLATE_LABELS: Record<LinhaProdutoTemplate, string> = {
  fotovoltaico: 'Fotovoltaico',
  carregador_veicular: 'Carregadores veiculares',
};

export interface Template {
  id: string;
  titulo: string;
  objetivo?: string;
  descricao?: string;
  instrucoes?: string;
  etapa_funil: string;
  /** Linha de produto à qual o template se aplica (padrão legado: fotovoltaico). */
  linha_produto?: LinhaProdutoTemplate;
  tipo_tarefa: 'acao' | 'pergunta' | 'checklist';
  prazo_horas?: number;
  prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
  ativo: boolean;
  ordem?: number;
  perguntas_spin?: any[];
  perguntas_formulario?: PerguntaFormulario[];
  conclusoes_automaticas?: ConclusaoAutomatica[];
}

// Constantes para templates
export const etapasFunil = [
  { value: 'lead-capturado', label: 'Lead Capturado' },
  { value: 'qualificacao', label: 'Qualificação' },
  { value: 'analise-necessidades', label: 'Análise de Necessidades' },
  { value: 'visita-tecnica', label: 'Visita Técnica' },
  { value: 'proposta-valor', label: 'Proposta de Valor' },
  { value: 'follow-up', label: 'Follow-up' },
  { value: 'negocio-fechado', label: 'Negócio Fechado' }
];

export const tiposTarefa = [
  { value: 'acao', label: 'Ação' },
  { value: 'pergunta', label: 'Pergunta' },
  { value: 'checklist', label: 'Checklist' }
];

export const prioridades = [
  { value: 'baixa', label: 'Baixa' },
  { value: 'media', label: 'Média' },
  { value: 'alta', label: 'Alta' },
  { value: 'urgente', label: 'Urgente' }
];

export interface TarefaLead {
  id: string;
  nome: string;
  tipo?: 'fisica' | 'juridica';
  etapa: string;
  telefone?: string;
  email?: string;
  parceiro_id?: string | null;
}

export interface TarefaVendedor {
  id: string;
  nome: string;
}

export interface Tarefa {
  id: string;
  titulo: string;
  descricao?: string;
  instrucoes?: string;
  status: TarefaStatus;
  prioridade: TarefaPrioridade;
  tipo_tarefa: TarefaTipo;
  etapa_criacao: string;
  data_criacao: string;
  data_vencimento?: string;
  data_inicio?: string;
  data_conclusao?: string;
  dias_restantes?: number | null;
  esta_atrasada: boolean;
  urgencia?: number;
  observacoes?: string;
  resultado_acao?: string;
  tempo_gasto_minutos?: number;
  template_id?: string;
  perguntas_formulario?: PerguntaFormulario[];
  respostas_formulario?: RespostaFormulario[];
  lead: TarefaLead | null;
  vendedor: TarefaVendedor | null;
  notas?: string | null;
  conclusao_automatica?: string; // Nome da conclusão automática aplicada
}

